// Maps each SuperAdmin panel page to the permission(s) required to see it.
// - An array means "any of these permissions grants access".
// - 'super_admin_only' means only the full super_admin role (no permission unlocks it).
// - A path with no entry here is open to any authenticated SuperAdmin (e.g. Dashboard
//   home redirect targets that don't correspond to a real page).
// `super_admin` role always has access to everything — this map is only consulted
// for limited roles (support, billing).
export const PAGE_PERMISSIONS = {
  '/superadmin/dashboard': ['view_analytics', 'view_reports', 'manage_organizations'],
  '/superadmin/organizations': ['manage_organizations'],
  '/superadmin/leads': ['manage_organizations'],
  '/superadmin/demo-bookings': ['manage_organizations'],
  '/superadmin/plans': ['manage_plans'],
  '/superadmin/promocodes': ['manage_plans'],
  '/superadmin/channel-partners': ['manage_channel_partners'],
  '/superadmin/blog': ['manage_resources_content'],
  '/superadmin/videos': ['manage_resources_content'],
  '/superadmin/other-products': ['manage_resources_content'],
  '/superadmin/notices': ['manage_organizations'],
  '/superadmin/app-versions': 'super_admin_only',
  '/superadmin/invoice-settings': ['manage_billing'],
  '/superadmin/settings': 'super_admin_only',
  '/superadmin/support': ['manage_support'],
  '/superadmin/admins': ['manage_users'],
  '/superadmin/audit-logs': ['view_reports'],
  // Reports section — all sub-reports require the same permission
  '/superadmin/renewal-report': ['view_reports'],
  '/superadmin/renewal-conversion': ['view_reports'],
  '/superadmin/renewal-agent-performance': ['view_reports'],
  '/superadmin/renewal-loss': ['view_reports'],
  '/superadmin/subscription-expiry': ['view_reports'],
  '/superadmin/sla-performance': ['view_reports'],
  '/superadmin/first-response': ['view_reports'],
  '/superadmin/ticket-resolution': ['view_reports'],
  '/superadmin/overdue-tickets': ['view_reports'],
  '/superadmin/escalations': ['view_reports'],
  '/superadmin/reopened-tickets': ['view_reports'],
  '/superadmin/ticket-closure': ['view_reports'],
  '/superadmin/ticket-trends': ['view_reports'],
  '/superadmin/customer-tickets': ['view_reports'],
  '/superadmin/product-tickets': ['view_reports'],
};

// The order pages are tried when picking a landing page for a limited-access admin
// (first one they can access wins).
export const DEFAULT_LANDING_ORDER = [
  '/superadmin/dashboard',
  '/superadmin/support',
  '/superadmin/organizations',
  '/superadmin/plans',
  '/superadmin/promocodes',
  '/superadmin/channel-partners',
  '/superadmin/admins',
  '/superadmin/invoice-settings',
  '/superadmin/audit-logs',
  '/superadmin/notices',
];

export const canAccessSuperAdminPage = (path, { isSuperAdmin, hasPermission }) => {
  if (isSuperAdmin) return true;
  const rule = PAGE_PERMISSIONS[path];
  if (!rule) return true;
  if (rule === 'super_admin_only') return false;
  return rule.some((permission) => hasPermission(permission));
};

export const getDefaultLandingPath = ({ isSuperAdmin, hasPermission }) => {
  if (isSuperAdmin) return '/superadmin/dashboard';
  const landing = DEFAULT_LANDING_ORDER.find((path) =>
    canAccessSuperAdminPage(path, { isSuperAdmin, hasPermission })
  );
  return landing || '/superadmin/dashboard';
};
